import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button/Button';
import { FiMail, FiInstagram } from 'react-icons/fi';

// Ahora, todo el contenido de la página de inicio vive aquí.
// Esto nos permite usar nuestros componentes de React, como <Button>.

const HomePage: React.FC = () => {
  return (
    <div>
      {/* SECCIÓN DE INICIO (HERO) */}
      <header id="inicio" className="hero-section">
        <h1 className="hero-title">JMK Producciones</h1>
        <p className="hero-subtitle">Mueve el cursor sobre la pantalla.</p>
        <div className="button-group">
          {/* Usamos <Link> para ir a la página de servicios */}
          <Link to="/servicios">
            {/* Este es nuestro componente <Button> con sus estilos */}
            <Button variant="secondary">Ver Servicios</Button>
          </Link>
          {/* Usamos <a> para ir a un ancla (#) en la misma página */}
          <a href="#contacto">
            <Button variant="primary">Contáctanos</Button>
          </a>
        </div>
      </header>

      <main>
        {/* SECCIÓN SOBRE NOSOTROS */}
        <section id="nosotros" className="section">
          <h2 className="section-title">Sobre Nosotros</h2>
          <p className="section-subtitle">
            En "JMK Studio" somos una empresa de producción multimedia dedicada a la creación de experiencias digitales que integran arte, diseño y tecnología. Contamos con un equipo multidisciplinario que nos permite ofrecer soluciones innovadoras y adaptadas a las necesidades de cada cliente.
          </p>
          <a href="#contacto">
            <Button variant="secondary">Hablemos de tu proyecto</Button>
          </a>
        </section>

        {/* SECCIÓN DE EQUIPO */}
        <section id="equipo" className="section">
          <h2 className="section-title">Nuestro Equipo</h2>
          <div className="team-grid">
            <div className="team-member">
              <h3>Maria Jose Guarin Zapata</h3>
              <p>Líder / Directora Creativa</p>
            </div>
            <div className="team-member">
              <h3>Karen Andrea Altamar Bautista</h3>
              <p>Gestor de Contenidos / Diseñador</p>
            </div>
            <div className="team-member">
              <h3>Jorge Andres Jaimes Celis</h3>
              <p>Desarrollador</p>
            </div>
          </div>
        </section>

        {/* SECCIÓN DE CONTACTO */}
        <section id="contacto" className="section">
          <h2 className="section-title">Hablemos</h2>
          <p className="section-subtitle">
            ¿Listo para transformar tus ideas en una realidad digital? Contáctanos.
          </p>
          <div className="contact-links">
            <a className="contact-link" href="mailto:jmkstudiomultimedia@gmail.com">
              <FiMail size={24}/>
              <span>jmkstudiomultimedia@gmail.com</span>
            </a>
            <a className="contact-link" href="https://instagram.com/JMK_Studio" target="_blank" rel="noopener noreferrer">
              <FiInstagram size={24}/>
              <span>@JMK_Studio</span>
            </a>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} JMK Studio. Cúcuta, Colombia. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default HomePage;